import { render } from "./TabHead.vue?vue&type=template&id=46f33028&scoped=true"
import script from "./TabHead.vue?vue&type=script&lang=js"
export * from "./TabHead.vue?vue&type=script&lang=js"

import "./TabHead.vue?vue&type=style&index=0&id=46f33028&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f33028"]])

export default __exports__